import React, { useEffect, useState } from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: any;
  data?: any;
};

export interface SelectProps {
  options: Option[];
  defaultValue?: Option;
  defaultValues?: Option[];
  className?: string;
  styles?: any; 
  onChange? : (value:any) => void;
  disabled?: boolean | false
  value?: Option | null | undefined
  values?: Option[] | null | undefined
  isMulti?: boolean
  placeHolder?: string
  components?: React.ComponentProps<typeof Select>["components"]
  formatOptionLabel?: (option: Option) => React.ReactNode;
}

const CommonSelectV2: React.FC<SelectProps> = ({isMulti, options, defaultValue, defaultValues, className, disabled, onChange, value, values, placeHolder, components, formatOptionLabel }) => {
  const [selectedOption, setSelectedOption] = useState<Option | undefined>(defaultValue);
  const [selectedOptions, setSelectedOptions] = useState<Option[] | undefined>(defaultValues);

  const handleChange = (option: any | any[] | null) => {
        if(isMulti) {
      setSelectedOptions([...option]);
      if(onChange){
        onChange(option?.map((opt:any)=>{
          return opt.value
        }))
      }
    } else {
      setSelectedOption(option || undefined);
      if(onChange){
        onChange(option?.value)
      }
    }
  };

  useEffect(() => {
    setSelectedOption(value || defaultValue || undefined);
  }, [defaultValue, value])

  useEffect(() => {
    setSelectedOptions(values || defaultValues || undefined);
  }, [defaultValues, values])
  
  const multiStyles = {
    multiValue: (base:any, state:any) => {
      return { ...base, border: '1px solid #F37438', backgroundColor: '#fbd1bd', borderRadius: 10 }
    },
    multiValueLabel: (base:any, state:any) => {
      return { ...base, fontWeight: 'bold', color: '#F37438', paddingRight: 6 }
    },
    multiValueRemove: (base:any, state:any) => {
      return { ...base, color:  '#F37438', borderBottomRightRadius: 10, borderTopRightRadius: 10} ;
    },
  };
  
  return (
    
      isMulti
      ?        <Select
          closeMenuOnSelect={isMulti}
          isMulti={isMulti}
          classNamePrefix="react-select"
          className={className}
          // styles={customStyles}
          options={options}
          value={selectedOptions?.length ? selectedOptions : null}
          onChange={handleChange}
          isClearable={true}
          placeholder={placeHolder || "Select"}
          isDisabled={disabled}
          styles={multiStyles}
          menuPlacement="auto"
          menuPosition="fixed"
          components={components || null}
          formatOptionLabel={formatOptionLabel || null}
        />

      :        <Select
          classNamePrefix="react-select"
          className={className}
          // styles={customStyles}
          options={options}
          value={ selectedOption || null}
          onChange={handleChange}
          placeholder={placeHolder || "Select"}
          isDisabled={disabled}
          menuPlacement="auto"
          menuPosition="fixed"
          components={components || null}
          formatOptionLabel={formatOptionLabel || null}
        />
  );
};

export default CommonSelectV2;
